import { FormikErrors } from "formik";
import "./AgentErrorSummary.scss";

const fieldLabels: Record<string, string> = {
  firstName: "Given Name",
  lastName: "Last Name",
  agent_email: "Email Address",
  mobileNo: "Mobile Number",
  mobileCode: "Country Code",
  designation: "Designation",
  licenseNumber: "License Number",
  agentProfileImageLive: "Profile Image",
};

interface AgentErrorSummaryProps {
  errors: FormikErrors<Record<string, any>>;
}

const AgentErrorSummary = ({ errors }: AgentErrorSummaryProps) => {
  const errorEntries = Object.entries(errors);
  if (!errorEntries.length) return null;

  return (
    <>
      <div className="error-summary">
        <div className="error-header">
          <span className="error-icon">!</span>
          <span>Errors in form!</span>
        </div>
        <div className="error-message">
          Please fix the following errors to submit the request
        </div>
      </div>

      <ul className="error-list">
        {errorEntries.map(([field, message]) => (
          <li key={field}>
            {fieldLabels[field] || field}{" "}
            {typeof message === "string" ? message : "Invalid value"}
          </li>
        ))}
      </ul>
    </>
  );
};

export default AgentErrorSummary;
